
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    className: {
      type: String,
    },
    error: {
      type: String,
      default: "",
    },
    noError: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    spellcheck: {
      type: [Boolean, String],
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const updateValue = (val: string) => {
      emit("update:value", val.trim());
    };
    return { updateValue };
  },
});
